/**
 * IsPlayerNearCondition - behavior tree condition checking player proximity.
 */

import { EngineClass } from '../../../../systems/ClassRegistry.js';
import { BehaviorStatus } from '../../BehaviorNode.js';
import { ConditionEvaluator, type ConditionEvaluatorOptions } from '../ConditionEvaluator.js';

import type { Blackboard } from '../../blackboard/Blackboard.js';

export interface IsPlayerNearConditionOptions extends ConditionEvaluatorOptions {
  range?: number;
}

@EngineClass('IsPlayerNearCondition')
export class IsPlayerNearCondition extends ConditionEvaluator {
  private range: number;

  constructor(options: IsPlayerNearConditionOptions = {}) {
    super({
      name: 'IsPlayerNear',
      ...options
    });

    this.range = options.range ?? 10.0;
  }

  protected override async onEvaluate(blackboard: Blackboard): Promise<BehaviorStatus> {
    const owner = this.getOwner(blackboard);
    if (!owner) {
      return BehaviorStatus.Failure;
    }

    // Use configured range directly
    const checkRange = this.range;

    // Get distance to player from blackboard (updated by blackboard.updateGameState())
    const distanceToPlayer = blackboard.getValue<number>('DistanceToPlayer');

    if (distanceToPlayer === undefined) {
      return BehaviorStatus.Failure;
    }

    // Check if player is within range
    return distanceToPlayer <= checkRange ? BehaviorStatus.Success : BehaviorStatus.Failure;
  }
}
